import axiosInstance from '../actions/AxiosInstance';
import api from '../actions/EndPoints';
import { log } from '../Utils';

/**
 * Hook providing document-related API services
 * @param {Function} dispatch - Redux dispatch function for state updates
 * @returns {Object} Object containing document service functions
 */
export const useDocumentServices = (dispatch) => {
    /**
     * Fetches available/current documents for the client
     * @param {string} key - API key for authentication
     */
    const getAvailableDocuments = async (key, externalGroupId) => {
        try {
            const getResponse = await axiosInstance.get(`${api.availableDocumentsAPI(externalGroupId)}`, {
                headers: { apikey: `${key}` }
            });
            if(getResponse) {
                const { data } = getResponse;
                dispatch({
                    type: 'AVAILABLE_DOCUMENTS',
                    releasedFinancialPlan: data?.releasedFinancialPlan,
                    releasedStrategyComparison: data?.releasedStrategyComparison,
                    releasedSelectedStrategy: data?.releasedSelectedStrategy
                });
            }
        } catch (err) {
            log(console.log(err));
        }
    };

    return { getAvailableDocuments };
};
